import {
  Inventory2Outlined as Inventory2OutlinedIcon,
  PlaylistAddCheckCircleOutlined as PlaylistAddCheckCircleOutlinedIcon,
  SwapHorizOutlined as SwapHorizOutlinedIcon,
  SyncAltOutlined as SyncAltOutlinedIcon
} from '@mui/icons-material'

export const stockOperationModes = [
  {
    key: 'manual',
    label: 'Movimiento manual',
    description: 'Entradas, salidas y ajustes no comerciales.',
    icon: SyncAltOutlinedIcon
  },
  {
    key: 'transfer',
    label: 'Transferencia',
    description: 'Movimiento entre bodegas origen y destino.',
    icon: SwapHorizOutlinedIcon
  }
]

export const uploadModes = [
  {
    key: 'initial-stock',
    label: 'Stock inicial',
    description: 'Carga existencias iniciales para items con control de inventario.',
    icon: PlaylistAddCheckCircleOutlinedIcon
  },
  {
    key: 'items',
    label: 'Items',
    description: 'Importa o actualiza el catalogo base usando SKU.',
    icon: Inventory2OutlinedIcon
  }
]
